import "./Divider.scss"

import React from "react"

export const Divider = () => {
  return <div className="c-divider text-gray-600">OR</div>
}
